import React, { use, useEffect } from 'react';
import { getPerfilEstablecimiento, postCrearEvento } from '../../Servicios/Servicios';
import { useSpinner } from '../../Component/spinner/spinner';

const ModalCrearEvento = ({ onClose, obtenerEventosData }) => {
  // Esta función se ejecuta al enviar el formulario
  const [nombreEvento, setNombreEvento] = React.useState('');
  const [valorIngreso, setValorIngreso] = React.useState('');
  const [fechaInicio, setFechaInicio] = React.useState('');
  const [fechaFin, setFechaFin] = React.useState('');
  const [hora, setHora] = React.useState('');
  const [horarios, setHorarios] = React.useState('');
  const [descripcion, setDescripcion] = React.useState('');
  const [imagen, setImagen] = React.useState('');
  const [habilitarCanciones, setHabilitarCanciones] = React.useState(false);
  const [latitud, setLatitud] = React.useState('');
  const [longitud, setLongitud] = React.useState('');
  const [nameFoto, setNameFoto] = React.useState('');
  const spinner = useSpinner();
  const diasSemana = [
    "Lunes",
    "Martes",
    "Miércoles",
    "Jueves",
    "Viernes",
    "Sábado",
    "Domingo",
  ];
  useEffect(() => {
    // Aquí podrías cargar datos iniciales si es necesario
    infoEstablecimiento();

  }, []);

  const infoEstablecimiento = async () => {
    spinner.show();
    const PerfilEstablecimiento = await getPerfilEstablecimiento();
    if (PerfilEstablecimiento.success) {
      const locations =  PerfilEstablecimiento.data.resultados.location.coordinates;
      setLatitud(locations[0]);
      setLongitud(locations[1]);
      spinner.hide();
    }else{
      console.error("Error al obtener el perfil del establecimiento:", PerfilEstablecimiento.message);
      spinner.hide();
    }
  }

  // Aquí podrías manejar el estado del formulario y la lógica para crear un evento
  const handleSubmit = async (e) => {
    spinner.show();
    e.preventDefault();
    // Lógica para enviar los datos del evento al servidor
    const formData = {
      latitud: latitud,
      longitud: longitud,
      nombreEvento: nombreEvento,
      cover: valorIngreso,
      horarios: horarios + " " + hora,
      descripcion: descripcion,
      fechaInicio: fechaInicio,
      fechaFin: fechaFin,
      habilitarCanciones: habilitarCanciones ? "SI" : "NO",
      imagen: imagen,
    };
    if (!nombreEvento || !valorIngreso || !fechaInicio || !fechaFin || !hora || !horarios) {
      console.error("Por favor, completa todos los campos obligatorios.");
      spinner.hide();
      return;
    }
    // Aquí podrías enviar formData a tu API para crear el evento
    const crearEvento = await postCrearEvento(formData);
    if (crearEvento.success) {
      alert(crearEvento.message);
      obtenerEventosData(); // Actualizar la lista de eventos después de crear uno nuevo
      onClose(); // Cerrar el modal después de crear el evento
      spinner.hide();
      setNombreEvento('');
      setValorIngreso('');
      setFechaInicio('');
      setFechaFin('');
      setHora('');
      setHorarios('');
      setDescripcion('');
      setImagen('');

    }else {
      alert("Error al crear el evento: " + crearEvento.message);
      console.error("Error al crear el evento:", crearEvento.message);
      spinner.hide();
    }

  }
  const convertirImagenABase64 = (e) => {
    const file = e.target.files[0];
    if (!file) return;
    if (!file.type.startsWith('image/')) {
      console.error("El archivo seleccionado no es una imagen");
      return;
    }
    const reader = new FileReader();
    reader.readAsDataURL(file);

    reader.onloadend = () => {
      const base64 = reader.result;
      setImagen(base64); // si estás usando useState
    };
    if (file.name) {
      setNameFoto(file.name);
    }

    reader.onerror = () => {
      console.error("Error al leer el archivo");
    };
  };
  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex justify-center items-center z-50">
        <div className="w-[400px] sm:w-[500px] rounded-2xl p-6 shadow-xl relative my-20 mx-8" id="CuadrosEstandarColor">

        {/* Cerrar */}
        <button onClick={onClose} className="absolute top-4 right-4 text-gray-400 hover:text-black text-xl font-bold">×</button>

        <h2 className="text-[#4F60A8] text-xl font-bold mb-4">Crear evento nuevo</h2>

        {/* Imagen */}
        <div htmlFor="file-upload" className="bg-[#D9D6F5] border border-[#4F60A8] text-center text-sm text-[#4F60A8] py-2 px-4 rounded-xl mb-3">
          <label htmlFor="file-upload" className="cursor-pointer">
            <div className="flex justify-center mb-2" htmlFor="file-upload">
              <span className="text-3xl" htmlFor="file-upload">📷</span>
            </div>
            Mínima resolución de 800px x 800px <br />
            Archivos PNG, JPEG
            {nameFoto && (
              <div className="mt-2 text-green-600 text-sm">
                Archivo seleccionado: {nameFoto}
              </div>
            )}
          </label>
        </div>
        <input
          type="file" 
          accept="image/*"
          id="file-upload"
          onChange={(e) =>convertirImagenABase64(e)}
          className="w-full file-input border rounded-lg px-4 py-2 bg-gray-100 placeholder-gray-500 mb-4"
          style={{ display: 'none' }} // Ocultar el input de archivo
        />

        {/* Inputs */}
        <div className="space-y-4">
          <input
            type="text"
            value={nombreEvento}
            onChange={(e) => setNombreEvento(e.target.value)}
            placeholder="Nombre del evento"
            className="w-full border rounded-lg px-4 py-2 bg-gray-100 placeholder-gray-500"
          />

          <input
            type="number"
            value={valorIngreso}
            onChange={(e) => setValorIngreso(e.target.value)}
            placeholder="Valor del ingreso"
            className="w-full border rounded-lg px-4 py-2 bg-gray-100 placeholder-gray-500"
          />
          <div className="flex gap-3">

          
            <select
              value={horarios}
              onChange={(e) => setHorarios(e.target.value)}
              className="w-1/2 border rounded-lg px-4 py-2 bg-gray-100 text-gray-700"
            >
              <option value="">Selecciona un día</option>
              {diasSemana.map((h) => (
                <option key={h} value={h}>
                  {h}
                </option>
              ))}
            </select>
            <select className="w-1/2 border rounded-lg px-4 py-2 bg-gray-100 text-gray-700" 
              value={hora}
              onChange={(e) => setHora(e.target.value)}>
              <option value="">Selecciona una hora</option>
              <option>5:00PM</option>
              <option>6:00PM</option>
              <option>7:00PM</option>
              <option>8:00PM</option>
              <option>9:00PM</option>
              <option>10:00PM</option>
              <option>11:00PM</option>
              <option>12:00AM</option>
              <option>1:00AM</option>
              <option>2:00AM</option>
              <option>3:00AM</option>
              <option>4:00AM</option>
              <option>5:00AM</option>
              <option>6:00AM</option>
              <option>7:00AM</option>
              <option>8:00AM</option>
            </select>
          </div>
          <div className="flex gap-3">
            <input
              type="date"
              placeholder="dd/mm/aaaa"
              className="w-1/2 border rounded-lg px-4 py-2 bg-gray-100 placeholder-gray-500"
              value={fechaInicio}
              onChange={(e) => setFechaInicio(e.target.value)}
            />
            <input
              type="date"
              placeholder="dd/mm/aaaa"
              className="w-1/2 border rounded-lg px-4 py-2 bg-gray-100 placeholder-gray-500"
              value={fechaFin}
              onChange={(e) => setFechaFin(e.target.value)}
            />
            
            
          </div>


          <textarea
            placeholder="Agregue una descripción"
            className="w-full border rounded-lg px-4 py-0.1 bg-gray-100 placeholder-gray-500"
            rows={2}
            value={descripcion}
            onChange={(e) => setDescripcion(e.target.value)}
          />

          <div className="flex items-center gap-2">
            <input type="radio" id="permitir" name="canciones" value={habilitarCanciones} onChange={(e) => setHabilitarCanciones(e.target.value)} />
            <label htmlFor="permitir" className="text-sm text-white">Permitir solicitud de canciones</label>
          </div>
        </div>

        {/* Botón */}
        <button
          onClick={handleSubmit}
          type="submit"
          className="mt-6 w-full bg-[#4F60A8] text-white py-3 rounded-full hover:bg-[#3d4b8a] transition">
          Crear evento
        </button>
      </div>
    </div>
  );
};


export default ModalCrearEvento;
